<script setup lang="ts">
import { computed } from 'vue'
import { itemScopeAttributes, useModelStrings, type ItemTemplateProps } from '@jantm/model-core'
import type {Invoice} from "@/types/Wiser/invoice.ts";
import {useRouter} from "vue-router";

/**
 * Custom item rendering for Invoice.
 *
 * Narrowing `entity` to `Invoice` is the whole point of a per-model template: the
 * props contract stays the one model-core passes, but inside this file the
 * entity is fully typed.
 */
const props = withDefaults(defineProps<ItemTemplateProps<Invoice>>(), { headingLevel: 3 })

const { t, locale } = useModelStrings(() => props.definition)

const scope = computed(() => itemScopeAttributes(props.definition))
const heading = computed(() => `h${props.headingLevel}` as const)
const router = useRouter()
const entityId = computed(() => props.entity?.id ?? 0)
const gotoDetail = function() {
  router.push({name: 'wiser-invoice', params: {id: entityId.value}})
}
</script>

<template>
  <article
    class="wiser-item invoice-item"
    v-bind="scope"
    @click="gotoDetail"
  >
    <component
      :is="heading"
      class="wiser-item__title invoice-item__title"
    >
      <span>{{ entity.id }}</span>
      <span class="wiser-item__badge invoice-item__badge">{{ entity.factuurnummer }}</span>
    </component>
    <span>{{ entity.factuurdatum }}</span>
    <span>{{ entity.omschrijving }}</span>
  </article>
</template>
